module.exports = __webpack_public_path__ + "img/bx-qapaper-setting-active.3a4dbfb3.svg";